import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import ComingSoonPage from './ComingSoonPage';

export default function Transactions() {

    const sampleTransactions = [
        {
            crypto: 'Bitcoin',
            network: 'BTC',
            address_hash: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
            value: '0.015 BTC',
            date: '2025-07-30'
        },
        {
            crypto: 'Ethereum',
            network: 'ETH',
            address_hash: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
            value: '2.4 ETH',
            date: '2025-07-28'
        },
        {
            crypto: 'USDT',
            network: 'ERC20',
            address_hash: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
            value: '1200 USDT',
            date: '2025-07-25'
        },
        {
            crypto: 'BNB',
            network: 'BSC',
            address_hash: 'bnb1grpf0955h0ykzq3ar5nmum7y6gdfl6lxfn46h2',
            value: '4.7 BNB',
            date: '2025-07-20'
        },
        {
            crypto: 'Polygon',
            network: 'MATIC',
            address_hash: '0x6c6ee5e31d828de241282b9606c8e98ea48526e2',
            value: '1000 MATIC',
            date: '2024-07-18'
        },
        {
            crypto: 'Solana',
            network: 'SOL',
            address_hash: '3Nd1g6vHyWaKqRmsEKbB7YebFTvPQw1N6QYp5eX3qEwr',
            value: '50 SOL',
            date: '2024-07-15'
        },
        {
            crypto: 'Bitcoin',
            network: 'BTC',
            address_hash: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
            value: '0.015 BTC',
            date: '2024-07-30'
        },
    ];


    const [transactions, setTransactions] = useState(sampleTransactions);
    const [searchTerm, setSearchTerm] = useState('');


    const [currentPage, setCurrentPage] = useState(1);
    const [entitiesPerPage, setEntitiesPerPage] = useState(5);

    const filteredTransactions = transactions.filter((txn) =>
        Object.values(txn).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const indexOfLastEntity = currentPage * entitiesPerPage;
    const indexOfFirstEntity = indexOfLastEntity - entitiesPerPage;
    const currentEntities = filteredTransactions.slice(indexOfFirstEntity, indexOfLastEntity);
    const emptyRowCount = entitiesPerPage - currentEntities.length;

    const handlePrevClick = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    };

    const handleNextClick = () => {
        setCurrentPage(prevPage => {
            const totalPages = Math.ceil(transactions.length / entitiesPerPage);
            return Math.min(prevPage + 1, totalPages);
        });
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDropdownChange = (e) => {
        setEntitiesPerPage(parseInt(e.target.value));
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(transactions.length / entitiesPerPage);
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(currentPage - Math.floor(maxPageNumbersToShow / 2), 1);
    const endPage = Math.min(startPage + maxPageNumbersToShow - 1, totalPages);
    const pageNumbers = [];

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }


    return (
        <div className='mt-5' data-aos='fade-in' data-aos-duration='1000'>
            <ComingSoonPage />
            <div className='flex flex-col lg:flex-row gap-3 items-center justify-between'>
                <p className='text-xl font-medium tracking-widest uppercase'>Transactions</p>
                <div className='flex items-center gap-3'>
                    <div className='border rounded-full flex items-center p-[2px]'>
                        <input className='rounded-full py-1 px-3 bg-transparent outline-none placeholder:text-white' placeholder='SEARCH' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}></input>
                        <div className='bg-white w-8 h-8 rounded-full text-black grid place-content-center'><FontAwesomeIcon icon={faMagnifyingGlass} /></div>
                    </div>
                </div>
            </div>
            <div className='bg-[#FFFFFF0D] rounded-xl mt-5 '>
                <div className='rounded-xl overflow-hidden overflow-x-auto'>
                    <table className='w-full text-center'>
                        <thead className='uppercase text-sm py-3 border-b border-white/10'>
                            <tr>
                                <th className='py-3 px-3 lg:px-0 font-semibold'>CRYPTO</th>
                                <th className='py-3 px-3 lg:px-0 font-semibold'>NETWORK</th>
                                <th className='py-3 px-3 lg:px-0 font-semibold'>ADDRESS</th>
                                <th className='py-3 px-3 lg:px-0 font-semibold'>VALUE</th>
                                <th className='py-3 px-3 lg:px-0 font-semibold'>DATE</th>
                            </tr>
                        </thead>
                        <tbody className='divide-y divide-white/10'>
                            {currentEntities.map((entity, index) => (
                                <tr key={index} className='h-16 text-sm 2xl:text-base text-center rounded-md font-bold font-normal'>
                                    <td className='px-5 md:px-0'>{entity.crypto}</td>
                                    <td className='px-5 md:px-0'>{entity.network}</td>
                                    <td className='px-5 md:px-0 relative group cursor-pointer'>
                                        <span>{entity.address_hash.slice(0, 12)}...</span>
                                        <div className="absolute -bottom-2 mb-2 left-1/2 -translate-x-1/2 w-max max-w-xs bg-black text-white text-xs px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity z-10 whitespace-nowrap">
                                            {entity.address_hash}
                                        </div>
                                    </td>
                                    <td className='px-5 md:px-0'>{entity.value}</td>
                                    <td className='px-5 md:px-0'>{entity.date}</td>
                                </tr>
                            ))}
                            {Array.from({ length: emptyRowCount }).map((_, index) => (
                                <tr key={`empty-${index}`} className='h-16'>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className='flex flex-col md:flex-row gap-3 md:gap-0 justify-between items-center py-3 px-5'>
                    <div className='flex items-center'>
                        <p className='text-end text-sm px-3 my-auto'>Showing
                            <select className='ml-2 outline-none rounded-md bg-transparent border-[1px]' onChange={handleDropdownChange} value={entitiesPerPage}>
                                <option className='text-black' value="5">5</option>
                                <option className='text-black' value="7">7</option>
                                <option className='text-black' value="10">10</option>
                            </select>
                            <span className='ml-2'>of <span className='ml-1'>{totalPages}</span></span>
                        </p>
                    </div>
                    <div className='flex justify-end gap-3 text-xs px-3'>
                        <div className='my-auto flex justify-center items-center gap-1'>
                            <FontAwesomeIcon icon={faChevronLeft} className='cursor-pointer bg-white/10 px-2.5 py-1.5 rounded shadow' onClick={handlePrevClick} />
                            {pageNumbers.map((pageNumber) => (
                                <button
                                    key={pageNumber}
                                    className={`px-2.5 py-1 rounded shadow ${pageNumber === currentPage ? 'font-bold bg-[#834CFF]' : 'bg-white/20'}`}
                                    onClick={() => handlePageClick(pageNumber)}
                                >
                                    {pageNumber}
                                </button>
                            ))}
                            <FontAwesomeIcon icon={faChevronRight} className='cursor-pointer bg-white/10 px-2.5 py-1.5 rounded shadow' onClick={handleNextClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}